export default __webpack_public_path__ + "img/4c747951540ee722.e62752d66159a4a43fb5d2efebd02c94.jpeg";